<template>
    <div class="home">
        <el-row style="overflow: hidden">
            <el-col :offset="1" :span="22">
                <el-container class="main-container" style="display: flex; flex-direction: column; height: 100vh;">
                    <el-header>
                        <el-menu :default-active="menuActiveIndex" mode="horizontal" router>
                            <el-menu-item v-for="item in visibleMenuItems" :key="item.index" :index="item.index">
                                <span>{{ item.label }}</span>
                                <el-badge
                                    v-if="item.index === '/omni' && omniTotalUnread > 0"
                                    :value="omniTotalUnread"
                                    :max="99"
                                    style="margin-left: 6px; vertical-align: middle;"
                                />
                            </el-menu-item>
                        </el-menu>
                    </el-header>
                    <el-main class="home-main-fill"
                        style="display: flex; flex: 1; flex-direction: column; min-height: 0;">
                        <keep-alive>
                            <router-view></router-view>
                        </keep-alive>
                    </el-main>
                    <el-footer style="height:40px;padding: 10px;display: flex;justify-content: center">
                        <div class="flex" style="width: 100%;justify-content: space-between;align-items: center">
                            <div class="left">
                                <span>当前版本：{{ version }}</span>
                                <el-link style="margin-left: 10px " type="primary" class="jump-effect"
                                    v-if="latestVersion.version > version" :href="latestVersion.url" target="_blank">
                                    <i class="el-icon-bell"></i>
                                    <span>{{ latestVersion.version > version ? '有新版本更新' : '最新版本' }} ，点击下载</span>
                                </el-link>
                            </div>
                            <div class="center">
                                <div class="flex" v-if="isLoggedIn"
                                    style="height:100%;justify-content: center;align-items: center">
                                    <div>当前登录用户：{{ user?.username }}</div>
                                    <div style="margin-left: 20px">登录时间：{{ user?.createdTime }}</div>
                                    <el-link type="danger" style="margin-left: 20px" @click="logout">登出</el-link>
                                    <el-divider direction="vertical"></el-divider>
                                    <el-link type="primary" @click="userConfigDialogVisible = true">
                                        用户配置
                                    </el-link>
                                    <el-divider direction="vertical"></el-divider>
                                    <el-link type="primary" @click="updatePwdDialogVisible = true">
                                        修改密码
                                    </el-link>
                                    <template v-if="hasMessageCenterPermission">
                                        <el-divider direction="vertical"></el-divider>
                                        <el-tooltip :content="unreadCount > 0 ? `消息中心（${unreadCount}条未读）` : '消息通知中心'" placement="top" :open-delay="200">
                                            <div class="footer-message-badge" :class="{ 'has-unread': unreadCount > 0 }" @click="messageCenterDialogVisible = true">
                                                <el-badge :value="unreadCount" :max="99" :hidden="unreadCount === 0" class="footer-bell-badge">
                                                    <span class="footer-bell-label">
                                                        <i class="el-icon-bell"></i>
                                                        <span style="margin-left: 4px;">消息通知</span>
                                                    </span>
                                                </el-badge>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </div>
                                <div class="flex" v-else>
                                    <div>您还没有登录，请先进行登录</div>

                                    <el-link type="primary" @click="loginDialogVisible = true"
                                        style="margin-left: 20px">
                                        登录
                                    </el-link>

                                </div>
                            </div>

                            <div class="right">

                                Powered by
                                <el-popover
                                    placement="top-start"
                                    width="300"
                                    trigger="hover">
                                    <el-image
                                        style="width: 300px; height: 400px"
                                        :src="contactImageUrl" 
                                        fit="fill"
                                        :preview-src-list="[contactImageUrl]"></el-image>
                                    <el-link :underline="false" type="primary" slot="reference">yuntao</el-link>
                                </el-popover>
                            </div>

                        </div>
                    </el-footer>
                </el-container>
            </el-col>
        </el-row>

        <el-dialog title="登录" :visible.sync="loginDialogVisible" top="30vh" width="25%" center
            :close-on-click-modal="false">
            <el-form ref="loginForm" :model="loginForm" label-width="80px" @submit.native.prevent="login">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="loginForm.username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="loginForm.password"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" native-type="submit" style="width: 100%">登 录</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>

        <el-dialog title="用户配置" :visible.sync="userConfigDialogVisible" top="10vh" width="50%" center
            :close-on-click-modal="false">
            <user-config :visible="userConfigDialogVisible" />
        </el-dialog>

        <el-dialog title="修改密码" :visible.sync="updatePwdDialogVisible" top="20vh" width="30%" center
            :close-on-click-modal="false">
            <update-pwd @close="updatePwdDialogVisible = false" />
        </el-dialog>

        <message-center-dialog
            :visible.sync="messageCenterDialogVisible"
            :unread-count="unreadCount"
            @change-unread="val => unreadCount = val"
            @open-config="handleOpenConfigFromMessageCenter"
        />
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import UserConfig from "@/views/order/user/config.vue";
import UpdatePwd from "@/views/order/user/updatePwd.vue";
import MessageCenterDialog from "@/views/message/MessageCenterDialog.vue";
import { showDesktopNotification } from "@/utils/browserNotification";
import wsGateway from '@/utils/websocketGateway';
import { CHAT_WS_ACTIONS, CHAT_WS_CHANNELS } from '@/constants/chatActions';

export default {
    name: 'AdminHome',
    components: { UpdatePwd, UserConfig, MessageCenterDialog },
    data() {
        return {
            messageCenterDialogVisible: false,
            unreadCount: 0,
            wsMessageUnsubscribe: null,
            wsOmniUnsubscribe: null,
            loginForm: {},
            loginDialogVisible: false,

            userConfigDialogVisible: false,
            updatePwdDialogVisible: false,

            version: '1.0.0',
            latestVersion: {
                version: '1.0.0'
            },

            intervalId: null,

            // 菜单配置：permissionCode 与权限码管理中的 code 对应，无 permissionCode 表示所有人可见
            menuItems: [
                { index: '/dashboard', label: '工作台' },
                { index: '/order/order', label: '订单管理', permissionCode: 'menu.order' },
                { index: '/omni', label: '全渠道客服', permissionCode: 'menu.omni' },
                { index: '/agent', label: 'AI 助手', permissionCode: 'menu.agent' },
                { index: '/order/proxy', label: '代理管理', permissionCode: 'menu.order.proxy' },
                { index: '/order/tokenUsage', label: '费用明细', permissionCode: 'menu.order.tokenUsage' },
                { index: '/order/report', label: '报表管理', permissionCode: 'menu.order.report' },

                // { index: '/toolbox/scale', label: '量表工具', permissionCode: 'menu.toolbox.scale' },
                { index: '/toolbox/delimiter', label: '格式互转', permissionCode: 'menu.toolbox.scale' },
                // { index: '/spss', label: 'SPSS 分析', permissionCode: 'menu.spss' },
                // { index: '/document/fileUploadRecords', label: '文档记录', permissionCode: 'menu.document.fileUploadRecords' },
                { index: '/admin/tenant', label: '租户管理', permissionCode: 'menu.admin.tenant' },
                { index: '/admin/user', label: '用户管理', permissionCode: 'menu.admin.user' },
                { index: '/admin/permission', label: '权限管理', permissionCode: 'menu.admin.permission' },
                { index: '/admin/device', label: '设备管理', permissionCode: 'menu.admin.device' },
                { index: '/admin/version', label: '版本管理', permissionCode: 'menu.admin.version' },
                // { index: '/admin/monitor', label: '服务器监控', permissionCode: 'menu.admin.monitor' },
                { index: '/admin/accessLog', label: '访问日志', permissionCode: 'menu.admin.accessLog' },
                { index: '/admin/dataCleanup', label: '数据清理', permissionCode: 'menu.admin.dataCleanup' },
                { index: '/admin/agentModel', label: '模型管理', permissionCode: 'menu.admin.agentModel' },
                { index: '/admin/agentStats', label: 'AI监控', permissionCode: 'menu.admin.agentStats' },
                // { index: '/admin/billingOverview', label: '余额总览', permissionCode: 'menu.admin.billingOverview' },
                // { index: '/admin/billingRecharge', label: '充值记录', permissionCode: 'menu.admin.billingRecharge' },
                // { index: '/admin/billingLedger', label: '余额流水', permissionCode: 'menu.admin.billingLedger' },
            ]
        }
    },
    computed: {
        ...mapState(['isLoggedIn', 'user']),
        /** 顶栏菜单高亮：工具箱子路由统一归到「工具箱」一项 */
        menuActiveIndex() {
            return this.$route.path;
        },
        // 根据权限码过滤可见菜单；未配置权限时 admin 默认看全部（兼容）
        visibleMenuItems() {
            const user = this.user
            return this.menuItems.filter(item => {
                if (!item.permissionCode) return true
                if (this.$isSuperAdmin(user) && (!user.permissions || user.permissions.length === 0)) return true
                return this.$hasPermission(item.permissionCode)
            })
        },
        // 联系图片 URL
        contactImageUrl() {
            return require('@/assets/wechat.png');
        },
        hasMessageCenterPermission() {
            return this.$hasPermission('action.messageCenter');
        },
        omniTotalUnread() {
            return this.$store.state.omni?.totalUnread || 0;
        }
    },
    methods: {
        login() {
            // 假设这里有登录请求，请求成功后获取用户信息
            let { username, password } = this.loginForm

            this.$http.post(`/login`, { username, password }).then(res => {
                this.$message.success('登录成功')

                // 提交登录状态到Vuex
                this.$store.dispatch('login', {
                    username,
                    password,
                    token: res.data,
                    createdTime: this.$dates.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
                });

                // 登录成功后重新获取用户信息
                this.$http.get(`/users/current`).then(res => {
                    this.$store.dispatch('login', res.data);
                    this.$nextTick(() => {
                        this.fetchUnreadCount();
                        this.initMessageCenterWebSocket();
                    });
                })

                // 登录成功后关闭弹窗
                this.loginDialogVisible = false;
            }).catch(() => {
            })


        },
        logout() {
            this.closeMessageCenterWebSocket();
            this.$http.get(`/logout`).then(() => {
                this.$message.success('登出成功')
                this.$store.dispatch('logout');
            }).catch(() => {
            })
        },

        fetchUnreadCount() {
            if (!this.isLoggedIn || !this.hasMessageCenterPermission) return;
            this.$http.get('/messageCenter/unreadCount').then(res => {
                if (res.data && res.data.success) {
                    this.unreadCount = res.data.data.unreadCount || 0;
                }
            }).catch(() => {});
        },

        handleOpenConfigFromMessageCenter() {
            this.messageCenterDialogVisible = false;
            this.userConfigDialogVisible = true;
        },

        initMessageCenterWebSocket() {
            if (!this.isLoggedIn) {
                this.closeMessageCenterWebSocket();
                return;
            }

            // 统一网关连接管理
            wsGateway.connect();

            // 订阅消息中心通道
            if (!this.wsMessageUnsubscribe) {
                this.wsMessageUnsubscribe = wsGateway.on('message', (payload) => {
                    this.handleMessageCenterEvent(payload);
                });
            }

            // 订阅全渠道客服通道（全局未读数同步与跨页面建单通知）
            if (!this.wsOmniUnsubscribe) {
                this.wsOmniUnsubscribe = wsGateway.on(CHAT_WS_CHANNELS.OMNI_CHAT, (payload) => {
                    if (!payload || !payload.action) return;
                    const { action, data } = payload;
                    if (action === CHAT_WS_ACTIONS.NEW_MESSAGE || action === CHAT_WS_ACTIONS.UNREAD_UPDATED) {
                        const { totalUnread, shopUnreadMap } = data || {};
                        this.$store.commit('omni/SET_UNREAD_SUMMARY', { totalUnread, shopUnreadMap });
                    } else if (action === CHAT_WS_ACTIONS.AUTO_ORDER_CREATED && this.$route.path !== '/omni') {
                        const { busCode, numberOfCopies, shopName, buyerNickname, orderCount, orders } = data || {};
                        const count = Number(orderCount) || (Array.isArray(orders) ? orders.length : 1);
                        const title = count > 1 ? `🤖 自动建单成功 (拆分 ${count} 个订单)` : '🤖 自动建单成功';
                        let detailHtml = `<div><b>订单号：</b>${busCode || '-'}</div>`;
                        if (count > 1 && Array.isArray(orders)) {
                            detailHtml += `<div style="margin: 4px 0; padding: 4px 6px; background: #f5f7fa; border-radius: 4px;">`;
                            orders.forEach((o, idx) => {
                                const lbl = o.label ? `[${o.label}] ` : `[任务${idx + 1}] `;
                                detailHtml += `<div style="font-size: 12px; color: #606266;">${lbl}${o.busCode} (${o.numberOfCopies}份)</div>`;
                            });
                            detailHtml += `</div>`;
                        }
                        this.$notify.success({
                            title,
                            dangerouslyUseHTMLString: true,
                            message: `
                                <div style="font-size: 13px; line-height: 1.6;">
                                    ${detailHtml}
                                    <div><b>店铺/买家：</b>${shopName || '-'} / ${buyerNickname || '-'}</div>
                                    <div><b>总份数：</b>${numberOfCopies || 1} 份</div>
                                    <div style="margin-top: 6px;">
                                        <a href="#/order/order" style="color: #409EFF; font-weight: bold; text-decoration: underline;">前往订单管理查看 &gt;</a>
                                    </div>
                                </div>
                            `,
                            duration: 10000
                        });
                    } else if (action === CHAT_WS_ACTIONS.AUTO_ORDER_FAILED && this.$route.path !== '/omni') {
                        const { reason, shopName, buyerNickname, orderSn } = data || {};
                        this.$notify.warning({
                            title: '⚠️ 自动建单未完成',
                            dangerouslyUseHTMLString: true,
                            message: `
                                <div style="font-size: 13px; line-height: 1.6;">
                                    <div><b>原因：</b>${reason || '未能识别到有效问卷信息'}</div>
                                    ${orderSn ? `<div><b>订单号：</b>${orderSn}</div>` : ''}
                                    <div><b>店铺/买家：</b>${shopName || '-'} / ${buyerNickname || '-'}</div>
                                </div>
                            `,
                            duration: 8000
                        });
                    }
                });
            }

            if (this.hasMessageCenterPermission) {
                this.fetchUnreadCount();
            }
        },

        handleMessageCenterEvent(payload) {
            if (!payload) return;
            try {
                if (payload.action === 'connected') {
                    if (typeof payload.data?.unreadCount === 'number') {
                        this.unreadCount = payload.data.unreadCount;
                    }
                } else if (payload.action === 'message_center_created') {
                    const msg = payload.data?.message;
                    if (typeof payload.data?.unreadCount === 'number') {
                        this.unreadCount = payload.data.unreadCount;
                    } else {
                        this.unreadCount += 1;
                    }

                    if (msg) {
                        const channels = this.user?.config?.notification?.channels;
                        const allowDesktop = channels ? channels.browserDesktop === true : false;
                        const allowInApp = channels ? channels.inApp !== false : true;

                        // 1. 系统桌面通知（唤醒与跳转）
                        if (allowDesktop) {
                            showDesktopNotification({
                                title: msg.title,
                                summary: msg.summary,
                                related: msg.related,
                                onClick: () => {
                                    if (msg.related?.orderId) {
                                        this.$router.push({
                                            path: msg.related.routerPath || '/order/order',
                                            query: {
                                                orderId: msg.related.orderId,
                                                busCode: msg.related.orderCode
                                            }
                                        });
                                    }
                                }
                            });
                        }

                        // 2. 前台卡片弹窗
                        if (allowInApp) {
                            let notifyType = 'success';
                            if (msg.type === 'order_exception') {
                                notifyType = 'error';
                            } else if (msg.type === 'shop_offline') {
                                notifyType = 'warning';
                            }
                            this.$notify({
                                title: msg.title,
                                message: msg.summary,
                                type: notifyType,
                                duration: 8000,
                                onClick: () => {
                                    if (msg.related?.routerPath) {
                                        this.$router.push({
                                            path: msg.related.routerPath,
                                            query: msg.related.orderId ? {
                                                orderId: msg.related.orderId,
                                                busCode: msg.related.orderCode
                                            } : undefined
                                        });
                                    }
                                }
                            });
                        }
                    }
                } else if (payload.action === 'message_center_read') {
                    if (typeof payload.data?.unreadCount === 'number') {
                        this.unreadCount = payload.data.unreadCount;
                    }
                }
            } catch (e) {
                console.error('[Home] 处理消息中心事件异常:', e);
            }
        },

        closeMessageCenterWebSocket() {
            if (typeof this.wsMessageUnsubscribe === 'function') {
                this.wsMessageUnsubscribe();
                this.wsMessageUnsubscribe = null;
            }
            if (typeof this.wsOmniUnsubscribe === 'function') {
                this.wsOmniUnsubscribe();
                this.wsOmniUnsubscribe = null;
            }
            if (!this.isLoggedIn) {
                wsGateway.disconnect();
            }
            this.unreadCount = 0;
        },

        getLatestVersion() {
            this.$http.get(`/version/latest`).then(res => {
                this.latestVersion = res.data || { version: '1.0.0' }
            })
        }
    },
    watch: {
        isLoggedIn(val) {
            if (val) {
                this.$nextTick(() => {
                    this.fetchUnreadCount();
                    this.initMessageCenterWebSocket();
                });
            } else {
                this.closeMessageCenterWebSocket();
            }
        },
        user: {
            handler() {
                if (this.isLoggedIn && this.hasMessageCenterPermission) {
                    this.fetchUnreadCount();
                    this.initMessageCenterWebSocket();
                } else {
                    this.closeMessageCenterWebSocket();
                }
            }
        }
    },
    created() {
        this.$http.get(`/users/current`).then(res => {
            this.$store.dispatch('login', res.data);
            this.$nextTick(() => {
                if (this.isLoggedIn && this.hasMessageCenterPermission) {
                    this.fetchUnreadCount();
                    this.initMessageCenterWebSocket();
                }
            });
        })

        this.$http.get(`/version`).then(res => {
            this.version = res.data.version
        })

        this.getLatestVersion()

        // 10分钟查询一次最新版本
        this.intervalId = setInterval(() => this.getLatestVersion(), 1000 * 60 * 10)
    },
    mounted() {
        if (this.isLoggedIn && this.hasMessageCenterPermission) {
            this.fetchUnreadCount();
            this.initMessageCenterWebSocket();
        }
    },
    beforeDestroy() {
        this.closeMessageCenterWebSocket();
        clearInterval(this.intervalId)
    }

}
</script>

<style lang="scss" scoped>
::v-deep .el-main {
    padding: 20px 20px 0 20px
}

/* 子页面根节点参与占满 main 剩余高度（纯 flex，不用 calc） */
::v-deep .home-main-fill>* {
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
}


.jump-effect {
    animation: bounce 1s ease infinite;
    display: inline-block;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-5px);
    }
}

/* 底部状态栏消息中心入口 */
.footer-message-badge {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 2px 10px;
    border-radius: 12px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    transition: all 0.25s ease;
    font-size: 12px;
    color: #475569;
    line-height: 1.5;

    &:hover {
        background: #e6f1fc;
        border-color: #409EFF;
        color: #409EFF;
    }

    &.has-unread {
        background: #fff5f5;
        border-color: #fca5a5;
        color: #ef4444;
        font-weight: 600;

        .el-icon-bell {
            color: #ef4444;
            animation: bell-swing 3.2s ease-in-out infinite;
            transform-origin: top center;
            display: inline-block;
        }
    }

    .footer-bell-label {
        display: inline-flex;
        align-items: center;

        .el-icon-bell {
            font-size: 13px;
        }
    }
}

/* 摆钟轻微摇晃动效 */
@keyframes bell-swing {
    0%, 65%, 100% {
        transform: rotate(0deg);
    }
    5%, 15% {
        transform: rotate(14deg);
    }
    10%, 20% {
        transform: rotate(-14deg);
    }
    25% {
        transform: rotate(8deg);
    }
    30% {
        transform: rotate(-8deg);
    }
    35% {
        transform: rotate(0deg);
    }
}

/* 底部铃铛角标微发光动效 */
::v-deep .footer-bell-badge .el-badge__content {
    font-weight: 700;
    font-size: 10px;
    padding: 0 4px;
    height: 15px;
    line-height: 13px;
    border: 1px solid #ffffff !important;
    background-color: #ef4444;
    box-shadow: 0 1px 4px rgba(239, 68, 68, 0.6) !important;
    animation: badge-glow 2s infinite ease-in-out;
}

@keyframes badge-glow {
    0%, 100% {
        box-shadow: 0 1px 4px rgba(239, 68, 68, 0.5);
    }
    50% {
        box-shadow: 0 2px 8px rgba(239, 68, 68, 0.9);
    }
}
</style>
